export default __webpack_public_path__ + "static/media/darkBluePoint.44eeacd8.png";